import React from 'react';
import PropTypes from 'prop-types';
import RicosViewer from './ricos-viewer';
import styles from './ricos-viewer-wrapper.scss';
class RicosViewerWrapper extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            viewerRef: null,
        };
        this.setViewerRef = (element) => this.setState({ viewerRef: element });
    }
    render() {
        const { isMobile, TextSelectionToolbar, TwitterButton, isTwitterEnabled, } = this.props;
        return (React.createElement("div", { className: styles.relativeContainer },
            React.createElement(RicosViewer, Object.assign({}, this.props, { setViewerRef: this.setViewerRef })),
            isTwitterEnabled && !isMobile ? (React.createElement(TextSelectionToolbar, { container: this.state.viewerRef }, (selectedText) => React.createElement(TwitterButton, { selectedText: selectedText }))) : null));
    }
}
RicosViewerWrapper.propTypes = {
    TextSelectionToolbar: PropTypes.elementType.isRequired,
    TwitterButton: PropTypes.elementType.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isTwitterEnabled: PropTypes.bool,
};
export default RicosViewerWrapper;
//# sourceMappingURL=ricos-viewer-wrapper.js.map